'use strict';

const Backbone = require('backbone/backbone');
const _ = require('underscore/underscore');

require('./IndexCredits.less');

module.exports = Backbone.View.extend({

    el: '.IndexCredits',

    events: {
        'click .IndexCredits-phone-content-inner-controls': 'onControlsClick',
        'click .IndexCredits-phone-content-inner-controls-prev': 'onRewindClick',
        'click .IndexCredits-phone-content-inner-controls-next': 'onRewindClick'
    },

    initialize: function () {
        _.bindAll(this, 'onVideoEnd', 'onVideoPlay', 'onVideoPause', 'updateTime', 'onResize', 'initVideos');

        this.videos = [];
        this.videos[0] = this.$('.IndexCredits-phone-content-inner video')[0];
        this.videos[1] = this.$('.IndexCredits-phone-content-inner video')[1];

        this.switchToVideo(0);

        this.updateTime();

        var date = new Date;
        setTimeout(function () {
            this.updateTime();
            setInterval(this.updateTime, 60000);
        }.bind(this), (60 - date.getSeconds()) * 1000);


        setTimeout(this.initVideos, 1000);

        $(window).on('resize', this.onResize);
        this.onResize();

        app.vent.on('contour-click', function () {
            this.onControlsClick();
        }.bind(this));
    },

    initVideos: function () {
        if (this.isVideosInitialized) {
            return;
        }

        this.videos[0].setAttribute('src', this.videos[0].getAttribute('data-src'));
        this.videos[0].load();
        this.videos[1].setAttribute('src', this.videos[1].getAttribute('data-src'));
        this.videos[1].load();

        this.isVideosInitialized = true;
    },

    onResize: function () {
        var w = this.$('.IndexCredits-phone-wrapper').width();
        var scale = w / 1789;
        this.$('.IndexCredits-phone-content-inner-time').css('font-size', 10.5 * scale + 'px');
    },

    updateTime: function () {
        var date = new Date;
        var mins = date.getMinutes();
        if (mins < 10) {
            mins = '0' + mins;
        }
        this.$('.IndexCredits-phone-content-inner-time').text(date.getHours() + ':' + mins);
    },

    onVideoEnd: function () {
        this.video.currentTime = 0;
    },

    onVideoPlay: function () {
        this.$('.IndexCredits-phone-content-inner-poster').remove();
        this.$('.IndexCredits-phone-content-inner-controls-playback')
            .addClass('show-pause')
            .removeClass('show-play');
        app.vent.trigger('music-playing');
    },

    onVideoPause: function () {
        this.$('.IndexCredits-phone-content-inner-controls-playback')
            .addClass('show-play')
            .removeClass('show-pause');
        app.vent.trigger('music-paused');
    },

    switchToVideo: function (ind) {
        if (this.curVideoIndex !== undefined) {
            var prevVideo = this.videos[this.curVideoIndex];
            !prevVideo.paused && prevVideo.pause();
            $(prevVideo).css('opacity', '');

            $(prevVideo).on('ended', this.onVideoEnd);
            $(prevVideo).on('play', this.onVideoPlay);
            $(prevVideo).on('pause', this.onVideoPause);
        }

        this.curVideoIndex = ind;
        this.video = this.videos[this.curVideoIndex];
        this.video.currentTime = 0;
        $(this.video).css('opacity', 1);

        $(this.video).on('ended', this.onVideoEnd);
        $(this.video).on('play', this.onVideoPlay);
        $(this.video).on('pause', this.onVideoPause);
    },

    onControlsClick: function (e) {
        if (e && e.target !== e.currentTarget) {
            return;
        }

        this.initVideos();

        this.video.muted = false;
        if (this.video.paused) {
            this.video.play();
        } else {
            this.video.pause();
        }
    },

    onRewindClick: function (e) {
        $(e.currentTarget).flashClass('clicked', 483);

        this.switchToVideo(1 - this.curVideoIndex);
    }
});
